<script>
import queryString from "query-string";
// import BasketFlatrate from "./components/baskets/BasketFlatrate.vue";
import UKBasketClassic from "./components/baskets/UKBasketClassic.vue";
import AEBasketClassic from "./components/baskets/AEBasketClassic.vue";
// import DACHBasketClassic from "./components/baskets/DACHBasketClassic.vue";
// import DACHBasketHardware from "./components/baskets/DACHBasketHardware.vue";
import DACHBasketHardwareUpfront from "./components/baskets/DACHBasketHardwareUpfront.vue";
import { CHECKOUT_LINKS } from "./constants/index";
import { store } from "./store";
import changeProduct from "./mixins/changeProduct";

// use this variable to switch default basket or to locally develop for different languages
// UK_CLASSIC | DE_HARDWARE | AE_CLASSIC
const defaultModel = "UK_CLASSIC";

let defaultSelectedLang = "de-DE";
let defaultSelectedRegion = "DE";
let defaultSelectedCurrency = "EUR";
let defaultIsProductFlatrate = true;

if (defaultModel === "DE_FLATRATE") {
  defaultSelectedLang = "de-DE";
  defaultSelectedRegion = "DE";
  defaultSelectedCurrency = "EUR";
  defaultIsProductFlatrate = true;
} else if (defaultModel === "AT_FLATRATE") {
  defaultSelectedLang = "de-AT";
  defaultSelectedRegion = "AT";
  defaultSelectedCurrency = "EUR";
  defaultIsProductFlatrate = true;
} else if (defaultModel === "UK_CLASSIC") {
  defaultSelectedLang = "en-UK";
  defaultSelectedRegion = "UK";
  defaultSelectedCurrency = "GBP";
  defaultIsProductFlatrate = false;
} else if (defaultModel === "DE_CLASSIC") {
  defaultSelectedLang = "de-DE";
  defaultSelectedRegion = "DE";
  defaultSelectedCurrency = "EUR";
  defaultIsProductFlatrate = false;
} else if (defaultModel === "DE_HARDWARE") {
  defaultSelectedLang = "de-DE";
  defaultSelectedRegion = "DE";
  defaultSelectedCurrency = "EUR";
  defaultIsProductFlatrate = false;
} else if (defaultModel === "AE_CLASSIC") {
  defaultSelectedLang = "en-AE";
  defaultSelectedRegion = "AE";
  defaultSelectedCurrency = "AED";
  defaultIsProductFlatrate = false;
}

export default /*#__PURE__*/ {
  name: "Basket", // vue component name
  props: {
    open: { type: Boolean, required: false },
    isProductFlatrate: {
      type: Boolean,
      required: false,
      default: defaultIsProductFlatrate,
    },
    helpMeChoose: { type: Boolean, required: false, default: true },
    isNuxt: { type: Boolean, default: false },
    referralCode: { type: String, default: "" },
    lang: { type: String, default: defaultSelectedLang },
    selectedRegion: { type: String, default: defaultSelectedRegion },
    selectedCurrency: { type: String, default: defaultSelectedCurrency },
    selectedProductIndex: { type: Number, default: 0 },
    checkoutId: { type: String, default: "" },
    vahaLinkX: {
      type: String,
      default:
        "https://vaha-uk.myshopify.com/cart/38603968741527:1,38603967791255:1,39618083946647:1,38603968348311:1",
    },
    vahaLinkS: {
      type: String,
      default:
        "https://vaha-uk.myshopify.com/cart/39596804079767:1,38603967791255:1,39618109636759:1,39618083946647:1,38603968348311:1",
    },
    vahaSEnabled: { type: Boolean, default: true },
    seeMoreLink: {
      type: Object,
      default: function() {
        return { to: "", href: "" };
      },
    },
  },
  components: {
    // BasketFlatrate,
    UKBasketClassic,
    AEBasketClassic,
    // DACHBasketHardware,
    DACHBasketHardwareUpfront,
  },
  mixins: [changeProduct],
  computed: {
    allowedPayments() {
      if (this.selectedRegionScoped === "UK") {
        return [
          { name: "paypal" },
          { name: "mastercard" },
          { name: "visa" },
          // { name: "klarna" },
          { name: "amex" },
        ];
      } else if (this.selectedRegionScoped === "AE") {
        return [
          // { name: "klarna" },
          { name: "mastercard" },
          { name: "visa" },
          { name: "amex" },
          { name: "google-pay" },
          { name: "apple-pay" },
        ];
      }
      if (this.isProductFlatrateScoped === true) {
        return [
          { name: "paypal" },
          { name: "mastercard" },
          { name: "visa" },
          { name: "amex" },
        ];
      } else {
        return [
          // { name: "klarna" },
          { name: "paypal" },
          { name: "mastercard" },
          { name: "visa" },
          { name: "amex" },
        ];
      }
    },
    selectedProduct() {
      return store.state.selectedProduct;
    },
    experimentRunning() {
      return store.state.experimentRunning;
    },
    products() {
      return store.state.products;
    },
    promoBoxVariant() {
      return store.state.promoBoxVariant;
    },
  },
  data() {
    return {
      activePromotion: store.state.activePromotion,
      checkoutLinks: CHECKOUT_LINKS,
      experimentsRunning: {
        EMmfUn4VQcibwYfV7XLi0w: false,
      },
      sidebarOpen: this.open,
      isOpen: false,
      isDebug: process.env.VUE_APP_DEBUG_MODE === "true" ?? true,
      vahaLinkXScoped: this.vahaLinkX,
      vahaLinkSScoped: this.vahaLinkS,
      selectedCurrencyScoped: this.selectedCurrency,
      isProductFlatrateScoped: this.isProductFlatrate,
      selectedProductIndexScoped: this.selectedProductIndex,
      helpMeChooseScoped: this.helpMeChoose,
      checkoutIdScoped: this.checkoutId,
      basketVersion: "UK",
      selectedLang: this.lang,
      selectedRegionScoped: this.selectedRegion,
      localizationData: {
        currentRegion: this.selectedRegion,
        currencyCode: this.selectedCurrency,
      },
    };
  },
  async mounted() {
    // should be en-UK but sometimes is en-uk
    // should be de-DE but sometimes is de-de
    const parsedArray = this.selectedLang.split("-");
    const parsedLanguageAndRegion = `${parsedArray[0].toLowerCase()}-${parsedArray[1].toUpperCase()}`;
    this.$i18n.locale = parsedLanguageAndRegion;

    const parsedGETparams = queryString.parse(window.location.search);
    if (parsedGETparams.version === "b") {
      store.commit("setIsExperimentRunning", true);
    } else {
      console.log("version a");
    }

    if (parsedGETparams.basketVersion === "UK") {
      this.basketVersion = "UK";
    }

    console.log(parsedGETparams);
    // this.selectedProduct = this.products[this.selectedProductIndexScoped];
    console.log(this.selectedProductIndexScoped);
    store.commit("setSelectedProduct", this.selectedProductIndexScoped);

    function gtag() {
      if (window.dataLayer != null) {
        window.dataLayer.push(arguments);
      }
    }

    console.log(this.selectedRegionScoped);

    gtag("event", "optimize.callback", {
      callback: (combination, experimentId, containerId) => {
        console.log(combination, experimentId, containerId);
        if (
          experimentId === "EMmfUn4VQcibwYfV7XLi0w" ||
          experimentId === "oHdPzUTeSRKo3nmfWLGSIw" ||
          experimentId === "QwuifDbCQHOJMStwjrvedQ" ||
          experimentId === "ij4EkYI0QfubwM58_nOvcQ"
        ) {
          console.log(combination);
          if (combination == 1) {
            console.log("basket start experiment", experimentId);
            store.commit("setExperimentRunning", experimentId);
            this.$root.$emit("updateCheckoutLinks");
          }
        }
      },
    });
  },
  created() {
    // Event listeners on root level. They level us to send event to parent app. The listeners are defined in the app
    this.$root.$on("checkoutButtonClicked", (status) => {
      this.$emit("checkoutButtonClicked", status);
    });

    this.$root.$on("changeProduct", (productID, updatedProduct) => {
      this.$emit("changeProduct", productID, updatedProduct);
    });

    this.$root.$on("linkClicked", () => {
      console.log("link clicked callback");
      this.$emit("linkClicked");
    });

    this.$root.$on("reviewsLinkClicked", () => {
      console.log("reviews link clicked callback");
      this.$emit("reviewsLinkClicked");
    });

    this.$root.$on("close", () => {
      this.$emit("close");
    });
    this.$root.$on("updateCheckoutLinks", () => {
      this.$emit("updateCheckoutLinks");
    });
  },
  methods: {
    setSidebarOpen(status) {
      this.open = status;
      if (status === false) {
        this.$emit("close");
      }
    },
  },
  watch: {
    selectedProductIndex: {
      handler(val, oldVal) {
        console.log("selectedproduct", val, oldVal);
        //store.commit("setSelectedProduct", val);
        // this.selectedProduct = this.products[val];
        // this.selectedProductIndex = val;

        this.selectedProductIndexScoped = val;
        if (val === -1) val = 0;
        const product = store.state.products[val];

        this.changeProduct(
          product,
          this.$t(product.id),
          this.selectedRegionScoped
        );
      },
    },
    selectedRegion: {
      handler(val) {
        if (val == "" || val == null) return;
        this.selectedRegionScoped = val;
      },
    },
    checkoutId: {
      handler(val) {
        if (val == "" || val == null) return;
        this.checkoutIdScoped = val;
        store.commit("setCheckoutId", this.checkoutIdScoped);
      },
    },
    vahaLinkX: {
      handler(val) {
        if (val == "" || val == null) return;
        this.vahaLinkXScoped = val;
      },
    },
    vahaLinkS: {
      handler(val) {
        if (val == "" || val == null) return;
        this.vahaLinkSScoped = val;
      },
    },
    selectedCurrency: {
      handler(val) {
        if (val == "" || val == null) return;
        this.selectedCurrencyScoped = val;
      },
    },
    isProductFlatrate: {
      handler(val) {
        if (val == "" || val == null) return;
        this.isProductFlatrateScoped = val;
      },
    },
  },
};
</script>

<template>
  <div class="v-shared-basket">
    <div v-if="isDebug === true">
      <p v-if="open === true">show if prop is true</p>
      <button @click="setSidebarOpen(true)">open</button>
      <button @click="setSidebarOpen(false)">close</button>
    </div>
    <b-sidebar
      :fullheight="true"
      :open="open"
      :overlay="false"
      :right="true"
      :can-cancel="false"
      mobile="fullwidth"
      scroll="keep"
      type="is-white"
      @close="$emit('close')"
    >
      <!-- DACH FLATRATE BASKET -->
      <!-- <BasketFlatrate
        v-if="selectedRegionScoped === 'DE' || selectedRegionScoped === 'AT' && isProductFlatrateScoped"
        :allowed-payments="allowedPayments"
        :is-product-flatrate="true"
        :selected-region-scoped="selectedRegionScoped"
        :help-me-choose-scoped="helpMeChooseScoped"
        :is-nuxt="isNuxt"
        :see-more-link="seeMoreLink"
        :selected-currency-scoped="selectedCurrencyScoped"
      /> -->
      <!-- DACH FLATRATE BASKET END -->
      <!-- DACH UPFRONT -->
      <DACHBasketHardwareUpfront
        v-if="selectedRegionScoped === 'DE' || selectedRegionScoped === 'AT'"
        :allowed-payments="allowedPayments"
        :is-product-flatrate="false"
        :selected-region-scoped="selectedRegionScoped"
        :help-me-choose-scoped="helpMeChooseScoped"
        :is-nuxt="isNuxt"
        :see-more-link="seeMoreLink"
        :selected-currency-scoped="selectedCurrencyScoped"
      />
      <!-- DACH UPFRONT END -->
      <!-- DACH CLASSIC-->
      <!-- <DACHBasketHardware
        v-if="selectedRegionScoped === 'DE' || selectedRegionScoped === 'AT'"
        :allowed-payments="allowedPayments"
        :is-product-flatrate="false"
        :selected-region-scoped="selectedRegionScoped"
        :help-me-choose-scoped="helpMeChooseScoped"
        :is-nuxt="isNuxt"
        :see-more-link="seeMoreLink"
        :selected-currency-scoped="selectedCurrencyScoped"
      /> -->
      <!-- DACH basket end -->
      <!-- UK basket start -->
      <UKBasketClassic
        v-else-if="selectedRegionScoped === 'UK'"
        :allowed-payments="allowedPayments"
        :is-product-flatrate="isProductFlatrate"
        :selected-region-scoped="selectedRegionScoped"
        :help-me-choose-scoped="helpMeChooseScoped"
        :is-nuxt="isNuxt"
        :see-more-link="seeMoreLink"
        :selected-currency-scoped="selectedCurrencyScoped"
      />
      <AEBasketClassic
        v-else-if="selectedRegionScoped === 'AE'"
        :allowed-payments="allowedPayments"
        :is-product-flatrate="isProductFlatrate"
        :selected-region-scoped="selectedRegionScoped"
        :help-me-choose-scoped="helpMeChooseScoped"
        :is-nuxt="isNuxt"
        :see-more-link="seeMoreLink"
        :selected-currency-scoped="selectedCurrencyScoped"
      />

      <!-- UK basket end -->
    </b-sidebar>
  </div>
</template>

<style lang="scss">
@import "~buefy/dist/buefy.css";
@import "./static/styles/bulma-custom.scss";
@import "./static/styles/global.scss";
@import "./static/styles/text-sizing";

@import "static/styles/bulma-custom.scss";
@import "static/styles/global.scss";
@import "static/styles/text-sizing";
/* stylelint-disable */
.basket-wrapper-a {
  .basket {
    &-container {
      color: $color-carbon-black;
    }

    &-wrapper {
      width: 100%;
    }

    &-title {
      @include font-16-medium();
      display: flex;
      justify-content: space-between;
      margin: 10px 0;

      a,
      .help-choose {
        font-size: 15px;
        color: $color-bold-black;
        text-decoration: underline !important;
        font-weight: 400 !important;
        cursor: pointer !important;
      }
    }

    &-title-span-holder {
      display: flex;
      align-items: center;
    }

    &-vaha-items {
      display: flex;
      width: 100%;
      justify-content: space-between;

      .basket-vaha-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: calc(50% - 8px);
        cursor: pointer;

        .basket-vaha-item-image-wrapper {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          padding-bottom: 10px;
          padding-top: 10px;
          width: 100%;
          height: 100%;
          background: $color-nearly-white;
          border-radius: 10px;
          border: 2px solid $color-pure-white;
        }

        &.active {
          .basket-vaha-item-image-wrapper {
            border-color: $color-classy-yellow;
            background: $color-pure-white;
          }
        }

        &.borderWhite {
          .basket-vaha-item-image-wrapper {
            border-color: $white !important;
          }
        }
      }
    }

    &-price {
      display: block;
      @include font-18-medium();

      &-period {
        font-weight: 400;
      }

      &-description {
        @include font-12();
      }

      &-summary {
        margin-top: 10px;
        padding-right: 1rem;

        li {
          @include font-14();
          position: relative;
          padding-left: 25px;

          &::before {
            background: url("https://uk-vaha.s3.eu-central-1.amazonaws.com/static/assets/icons/check@2x.svg")
              center no-repeat;
            background-size: cover;
            content: "";
            height: 15px;
            left: 0;
            position: absolute;
            top: 0;
            width: 15px;
          }
        }
      }

      &--big {
        @include font-22-medium();
      }
    }

    &-list-price-wrapper {
      display: flex;
      align-items: flex-end;

      .basket-price {
        line-height: 14px;
      }

      .basket-price-hint {
        font-size: 12px;
        font-weight: 400;
      }
    }

    &-payments {
      &-container {
        text-align: center;
        margin: 1.5rem 0 1rem;

        @include desktop() {
          text-align: left;
        }
      }

      &-icon {
        display: inline-block;
        margin: 4px 8px 0 0;
      }
    }

    &-payments-button {
      width: 100%;
      justify-content: space-between;

      @include desktop() {
        width: auto;
      }
    }
  }

  .separator {
    border-top: 1px solid $color-carbon-black;
    width: 100%;

    &--light {
      @extend .separator;
      border-color: $color-stone-grey;
    }
  }

  .icon-row {
    align-items: center !important;
  }

  .yellow-wrapper {
    background: #ffd26e;
    border-radius: 4px;
    padding: 0 10px 10px;

    .basket-price-summary {
      width: 100%;
      li {
        margin-bottom: 10px;
        align-items: flex-end;
        display: flex;
        justify-content: space-between;
        &::before {
          background: url("https://uk-vaha.s3.eu-central-1.amazonaws.com/assets/icons/check-white.svg")
            center no-repeat;
        }

        .list-content {
          width: 180px;
        }
      }
    }

    .special-launch-wrapper {
      flex-direction: column;

      .basket-special-launch-terms {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding-right: 1rem;
        color: #222222 !important;

        .vaha-text--underlined {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
  }

  .price {
    font-size: 18px;
    display: flex;
    align-items: flex-end;

    .crossed-price {
      text-decoration-line: line-through;
      text-align: right;
    }

    .recent-price {
      margin-left: 5px;
      font-weight: 600;
    }
  }

  .vaha-icon-calendar {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .delivery-notes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @include desktop {
      display: block;
    }
    .vaha-icon {
      @include desktop {
        display: block;
        text-align: center;
        height: 40px;
        margin-bottom: 0.5rem !important;
      }
    }

    .vaha-text {
      display: inline-block;
      width: calc(100% - 65px);
      font-weight: bold;

      @include desktop {
        width: 100%;
      }
    }
  }
}

.basket-wrapper-b {
  .basket-vaha-item-product-name {
    text-align: center;
  }

  .basket {
    &-container {
      color: $color-carbon-black;
    }

    &-wrapper {
      width: 100%;
    }

    &-title {
      @include font-16-medium();
      display: flex;
      justify-content: space-between;
      margin: 10px 0;

      a,
      .help-choose {
        font-size: 15px;
        color: $color-bold-black;
        text-decoration: underline !important;
        font-weight: 400;
        cursor: pointer !important;
      }
    }

    &-title-span-holder {
      display: flex;
      align-items: center;
    }

    &-vaha-items {
      display: flex;
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;

      .basket-vaha-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: calc(50% - 8px);
        cursor: pointer;

        .font-18 {
          @include font_18();
        }

        .font-16 {
          @include font_16();
        }

        .font-14 {
          @include font_14();
        }

        .strong {
          font-weight: 700;
        }

        .light {
          font-weight: 400;
        }

        .basket-vaha-item-image-wrapper {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          padding-bottom: 10px;
          padding-top: 10px;
          width: 100%;
          height: 100%;
          background: $color-nearly-white;
          border-radius: 10px;
          border: 2px solid $color-pure-white;

          &--uk {
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 10px;
          }
        }

        &.fullWidth {
          width: 100%;
          flex-direction: row;
          justify-content: flex-start;

          .basket-vaha-item-image-wrapper {
            padding: 0;
            align-items: flex-start;
            width: 30%;
            margin-right: auto;
          }
        }

        &.active {
          .basket-vaha-item-image-wrapper {
            border-color: $color-classy-yellow;
            background: $color-pure-white;
          }
        }

        &.borderWhite {
          .basket-vaha-item-image-wrapper {
            border-color: $white !important;
            background: $white !important;

            img {
              width: 85%;
            }
          }
        }
      }
    }

    &-price {
      display: block;
      @include font-18-medium();

      &-period {
        font-weight: 400;
      }

      &-description {
        @include font-12();
      }

      &-summary {
        margin-top: 10px;
        padding-right: 1rem;

        li {
          @include font-14();
          position: relative;
          padding-left: 0;
        }
      }

      &--big {
        @include font-22-medium();
      }
    }

    &-list-price-wrapper {
      display: flex;
      align-items: flex-end;

      .basket-price {
        line-height: 14px;
        &.experiment-wvSDVbi8R6KyxCB9T0CkrA {
          font-size: 14px !important;
        }
      }

      .basket-price-hint {
        font-size: 12px;
        font-weight: 400;
      }
    }

    &-payments {
      &-container {
        text-align: center;
        margin: 1.5rem 0 1rem;

        @include desktop() {
          text-align: left;
        }
      }

      &-icon {
        display: inline-block;
        margin: 4px 8px 0 0;
      }
    }

    &-payments-button {
      width: 100%;
      justify-content: space-between;

      @include desktop() {
        width: auto;
      }
    }
  }

  .basket-payments-button {
    width: 100% !important;
    text-align: center;
    display: flex;
    justify-content: center !important;

    &.fixed {
      position: fixed;
      bottom: 20px;
      width: auto !important;
    }

    .icon {
      // display: none;
    }
  }

  .separator {
    border-top: 1px solid $color-carbon-black;
    width: 100%;

    &--light {
      @extend .separator;
      border-color: $color-stone-grey;
    }
  }

  .icon-row {
    align-items: center !important;
  }

  .yellow-wrapper {
    background: #ffd26e;
    border-radius: 4px;
    padding: 10px;

    .basket-price-summary {
      width: 100%;
      li {
        margin-bottom: 10px;
        align-items: flex-end;
        display: flex;
        justify-content: space-between;
        &::before {
          background: url("https://uk-vaha.s3.eu-central-1.amazonaws.com/assets/icons/check-white.svg")
            center no-repeat;
        }

        .list-content {
          width: 180px;
        }
      }
    }

    .special-launch-wrapper {
      flex-direction: column;

      .basket-special-launch-terms {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        padding-right: 1rem;
        color: #222222 !important;

        .vaha-text--underlined {
          margin-top: 10px;
          font-size: 14px;
        }
      }
    }
  }

  .price {
    font-size: 18px;
    display: flex;
    align-items: flex-end;

    .crossed-price {
      text-decoration-line: line-through;
      text-align: right;
    }

    .recent-price {
      margin-left: 5px;
      font-weight: 600;
    }
  }

  .vaha-icon-calendar {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .delivery-notes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    @include desktop {
      display: block;
      padding-bottom: 20px;
    }
    &.experiment-13-09 {
      @include desktop {
        display: block;
        padding-bottom: 100px;
      }
    }
    .vaha-icon {
      @include desktop {
        margin-bottom: 0.5rem !important;
        display: block;
        text-align: center;
        height: 40px;
      }
    }

    .vaha-text {
      font-size: 12px;
      display: inline-block;
      width: calc(100% - 65px);

      @include desktop {
        width: 100%;
      }
    }
  }
}

.basket-wrapper-c {
  .font-20 {
    font-size: 20px;
  }

  .font-13 {
    font-size: 13px;
  }

  .font-18 {
    font-size: 18px;
  }

  .font-400 {
    font-weight: 400;
  }

  .basket-container.basket-body {
    margin-top: 20px;
  }

  .basket-promo-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 15px;
    background: #ffd26e;
    margin-bottom: 20px;
    margin-top: 20px;
    box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.25);

    .basket-promo-box-items {
      margin: 25px 0 15px;
    }

    .basket-promo-box-item {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
    }

    .basket-promo-box-item-price-holder {
      display: flex;
      .basket-promo-box-item-price-before {
        text-decoration: line-through;
      }

      .basket-promo-box-item-price-currency {
        margin: 0 5px;
      }
    }

    .basket-promo-box-link {
      margin: 0 auto;
      text-align: center;
      max-width: 60%;
      line-height: 14px;
      a {
        color: #000 !important;
        text-decoration: underline;
        font-size: 12px !important;
      }
    }
  }

  .basket-vaha-item-product-name {
    text-align: center;
  }

  .basket-product-title {
    margin-bottom: 15px;
    color: #000;
  }

  .basket-image-selector--new {
    display: flex;
    justify-content: space-between;

    .basket-vaha-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: calc(50% - 16px);
    }

    .basket-vaha-item-image-wrapper {
      display: flex;
      box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.25);
      border: 2px solid white;
      min-height: 160px;
      justify-content: center;
      align-items: flex-end;
      width: 100%;
      cursor: pointer;

      &.active {
        border-color: $color-classy-yellow;
        background: $color-pure-white;
        box-shadow: none;
      }

      img {
        max-height: 80%;
        margin-bottom: 10px;
      }
    }
  }
  .basket-help-me-choose {
    text-align: center;
    display: flex;
    justify-content: center;

    .help-choose {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .tooltip-open {
    text-decoration: underline;
    cursor: pointer;
  }

  .basket-payments-button {
    width: 100% !important;
    text-align: center;
    display: flex;
    justify-content: center !important;

    &.fixed {
      position: fixed;
      bottom: 20px;
      width: auto !important;
    }

    .icon {
      // display: none;
    }
  }

  .basket-footer-prices {
    display: flex;
    justify-content: space-around;
    align-items: center;

    .basket-footer-price-item {
      font-size: 20px;
      font-weight: 700;
      text-align: center;
      width: 33%;

      span {
        font-size: 18px;
        color: #5f5f5f;
      }
    }
  }

  .basket-footer-copy {
    margin-top: 1.5rem;
    text-align: center;
    display: flex;
    justify-content: center;
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 12px;
    padding-bottom: 60px;
    margin-bottom: 80px;

    @include desktop() {
      margin-bottom: 80px;
    }
  }

  .basket-footer {
    @media (max-width: 481px) {
      margin-bottom: 75px;
    }
  }

  .icon-dark {
    path {
      fill: #000;
    }
  }

  .basket-icon-text {
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;

    svg {
      height: 40px;
      width: 40px;
      margin-right: 15px;

      path {
        fill: #feba50;
      }
    }
  }

  .basket {
    &-container {
      color: $color-carbon-black;
    }

    &-wrapper {
      width: 100%;
    }

    &-title {
      @include font-16-medium();
      display: flex;
      justify-content: space-between;
      margin: 10px 0;

      a,
      .help-choose {
        font-size: 15px;
        color: $color-bold-black;
        text-decoration: underline !important;
        font-weight: 400;
        cursor: pointer !important;
      }
    }

    &-title-span-holder {
      display: flex;
      align-items: center;
    }

    &-vaha-items {
      display: flex;
      width: 100%;
      justify-content: space-between;

      .basket-vaha-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        cursor: pointer;

        .font-18 {
          @include font_18();
        }

        .font-16 {
          @include font_16();
        }

        .font-14 {
          @include font_14();
        }

        .strong {
          font-weight: 700;
        }

        .light {
          font-weight: 400;
        }

        .basket-vaha-item-image-wrapper {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          padding-bottom: 10px;
          padding-top: 10px;
          width: 100%;
          height: 100%;
          background: $color-nearly-white;
          border-radius: 10px;
          border: 2px solid $color-pure-white;

          &--uk {
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            margin-bottom: 10px;
          }
        }

        &.fullWidth {
          width: 100%;
          flex-direction: row;
          justify-content: flex-start;

          .basket-vaha-item-image-wrapper {
            padding: 0;
            align-items: flex-start;
            width: 30%;
            margin-right: auto;
          }
        }

        &.active {
          .basket-vaha-item-image-wrapper {
            border-color: $color-classy-yellow;
            background: $color-pure-white;
          }
        }

        &.borderWhite {
          .basket-vaha-item-image-wrapper {
            border-color: $white !important;
            background: $white !important;

            img {
              width: 85%;
            }
          }
        }
      }
    }

    &-price {
      display: block;
      @include font-18-medium();

      &-period {
        font-weight: 400;
      }

      &-description {
        @include font-12();
      }

      &-summary {
        margin-top: 10px;
        padding-right: 1rem;

        li {
          @include font-14();
          position: relative;
          padding-left: 0;
        }
      }

      &--big {
        @include font-22-medium();
      }
    }

    &-list-price-wrapper {
      display: flex;
      align-items: flex-end;

      .basket-price {
        line-height: 14px;
      }

      .basket-price-hint {
        font-size: 12px;
        font-weight: 400;
      }
    }

    &-payments {
      &-container {
        text-align: center;
        margin: 1.5rem 0 1rem;

        @include desktop() {
          text-align: left;
        }
      }

      &-icon {
        display: inline-block;
        margin: 4px 8px 0 0;
      }
    }

    &-payments-button {
      width: 100%;
      justify-content: space-between;

      @include desktop() {
        width: auto;
      }
    }
  }

  .separator {
    border-top: 1px solid $color-carbon-black;
    width: 100%;

    &--light {
      @extend .separator;
      border-color: $color-stone-grey;
    }
  }

  .icon-row {
    align-items: center !important;
  }

  .price {
    font-size: 18px;
    display: flex;
    align-items: flex-end;

    .crossed-price {
      text-decoration-line: line-through;
      text-align: right;
    }

    .recent-price {
      margin-left: 5px;
      font-weight: 600;
    }
  }

  .vaha-icon-calendar {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .delivery-notes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    @include desktop {
      display: block;
      padding-bottom: 20px;
    }
    &.experiment-13-09 {
      @include desktop {
        display: block;
        padding-bottom: 100px;
      }
    }
    .vaha-icon {
      @include desktop {
        display: block;
        text-align: center;
        height: 40px;
        margin-bottom: 0.5rem !important;
      }
    }

    .vaha-text {
      @include font-14();
      display: inline-block;
      width: calc(100% - 65px);

      @include desktop {
        width: 100%;
      }
    }
  }
}

.basket-payments-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: fit-content;

  .basket-payments-icon {
    max-width: 60px;
  }

  &.experiment-wvSDVbi8R6KyxCB9T0CkrA {
    justify-content: flex-start;
  }
}

.mb-big {
  margin-bottom: 100px;
  @include desktop() {
    margin-bottom: 0;
  }
}

.fixed {
  position: fixed;
  padding: 40px;
  bottom: 0;
  width: 320px;
  padding-left: 1.5rem;
  padding-right: 25px;
  margin-left: -24px;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0px -20px 15px rgb(255 255 255 / 75%);
  display: flex;
  justify-content: flex-end;

  @media (min-width: 420px) {
    width: 420px;
  }

  .basket-payments-button {
    width: auto !important;
  }

  .dach-extra-copy {
    text-align: center;
    padding: 0 5px;
  }
}

.basket-promo-special {
  text-align: center;
  border: 1px solid #000;
  font-weight: 700;

  h3 {
    font-size: 20px;
    line-height: 30px;
  }
}

.mt-negative-30 {
  margin-top: -40px;
  @media (max-width: 481px) {
    margin-top: -130px;
  }
}

.pb-30 {
  padding-bottom: 30px;
  @media (max-width: 481px) {
    padding-bottom: 100px;
  }
}

.has-text-linethrough {
  text-decoration: line-through;
}

.font-12 {
  @include font-12();
}
/* stylelint-enable */
</style>
